export default "__VITE_ASSET__CSbr$8AW__"